import { createFileRoute } from "@tanstack/react-router";
import { Topbar } from "@/components/calv/Topbar";
import { Footer } from "@/components/calv/Footer";
import { Hero } from "@/components/calv/Hero";
import { Section } from "@/components/calv/Section";
import { LighthouseChecker } from "@/components/calv/LighthouseChecker";
import { SITE_URL } from "@/lib/locale";

const TITLE = "Lighthouse live check — Calvarius";
const DESC =
  "Instant Lighthouse audit for any URL: performance, accessibility, best practices, SEO and Core Web Vitals — plus top 3 improvement opportunities.";
const URL_ = `${SITE_URL}/en/tools/lighthouse-check`;
const ALT = `${SITE_URL}/tools/lighthouse-check`;

export const Route = createFileRoute("/en/tools/lighthouse-check")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL_ },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "de_DE" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: URL_ },
      { rel: "alternate", hrefLang: "en", href: URL_ },
      { rel: "alternate", hrefLang: "de", href: ALT },
      { rel: "alternate", hrefLang: "x-default", href: ALT },
    ],
  }),
  component: LighthouseCheckEN,
});

function LighthouseCheckEN() {
  return (
    <>
      <Topbar />
      <main id="main">
        <Hero
          variant="short"
          number="01"
          eyebrow="Tool"
          headline={<>Lighthouse live check — <em>any URL, instantly.</em></>}
          lead="Real Google PageSpeed Insights audit for any page. Four Lighthouse scores, Core Web Vitals, top 3 improvement opportunities. In about 30 seconds."
          metaStrip={["Google PageSpeed API", "Mobile · simulated 4G", "Three audits / 24 h"]}
          breadcrumbs={[{ label: "Start", to: "/en" }, { label: "Tools", to: "/en/tools" }, { label: "Lighthouse check" }]}
        />

        <Section number="02" kicker="Audit" headline={<>Enter URL. <em>Run audit.</em></>} variant="tinted">
          <LighthouseChecker locale="en" />
        </Section>
      </main>
      <Footer />
    </>
  );
}
